import api from "./api";

// Catálogo de tags SÓ DE PROJETOS (separado do de tarefas). Mesmo molde de tags.ts.
export interface ProjetoTag {
  id: string;
  slug: string;
  nome: string;
  cor: string;
  icone: string;
  ativo: boolean;
  ordem: number;
}

export async function listarProjetoTags(opts?: { todos?: boolean }) {
  const r = await api.get(`/projeto-tags${opts?.todos ? "?todos=1" : ""}`);
  return r.data.data as ProjetoTag[];
}

export async function criarProjetoTag(dados: { nome: string; slug?: string; cor?: string; icone?: string; ordem?: number }) {
  const r = await api.post("/projeto-tags", dados);
  return r.data.data as ProjetoTag;
}

export async function atualizarProjetoTag(id: string, dados: Partial<{ nome: string; cor: string; icone: string; ativo: boolean; ordem: number }>) {
  const r = await api.patch(`/projeto-tags/${id}`, dados);
  return r.data.data as ProjetoTag;
}

export async function excluirProjetoTag(id: string) {
  await api.delete(`/projeto-tags/${id}`);
}
